import script from "./PaginatorBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginatorBar.vue?vue&type=script&setup=true&lang=js"

import "./PaginatorBar.vue?vue&type=style&index=0&id=d85a3944&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d85a3944"]])

export default __exports__